import {v2CreateRequestBody, v3CreateRequestBody} from "./v2Questions/SubmissionBuilder";
import {saveScanSuccessImagesEnabled, isNextGenEnabled} from "../../AppSettings";
import moment from "moment/moment";

export const mapFormValuesToRequestBody = (raw_form_data, dateFormat) => {

    const form_data = Object.entries(raw_form_data)
        .map((entry) => {
            let [field_name, value] = entry;

            //formik requires blanks to be specified by empty strings
            if (value === "") {
                value = null;
            }
            // Radio buttons can only return strings as their values
            if (value === "true") {
                value = true;
            }
            if (value === "false") {
                value = false;
            }
            if (
                (field_name === "face_height" ||
                field_name === "nose_width" ||
                field_name === "nose_depth")
                 && !isNextGenEnabled()  // NextGen mugshot sends these values as numbers if it
                                         // is not manual measure.  Let V3CreateRequestBody conditionally change it to
                                         // a string.
            ) {
                value = value.toString();
            }
            if (
                field_name === "first_name" ||
                field_name === "last_name"
            ) {
                value = value.toString();
            }
            return [field_name, value];
        })
        .reduce((acc, transformed) => {
            const [k, v] = transformed;
            acc[k] = v;
            return acc;
        }, {});

    // For now if nextGen is enabled we send nextGen
    let response = isNextGenEnabled() ?
                        v3CreateRequestBody(form_data, dateFormat) :
                        v2CreateRequestBody(form_data, dateFormat);


    if( !isNextGenEnabled() && form_data.mugshot_scan_info) {
        response.fitting_details.mugshot_scan_info = form_data.mugshot_scan_info;
    }

    if ( !isNextGenEnabled() && saveScanSuccessImagesEnabled()) {

        const sizing_images = {};

        if(form_data.front_image) { sizing_images.front = form_data.front_image }
        if (form_data.left_image) { sizing_images.left = form_data.left_image }
        if (form_data.right_image) { sizing_images.right = form_data.right_image }

        if( Object.keys(sizing_images).length > 0) {
            response.fitting_details.sizing_images = sizing_images;
        }

    }

    return response;
};

export const normalizeDateFormat = (date, currentDateFormat) => {
    // The API expects this date format in the request
    const apiDateFormat = "MM/DD/YYYY";
    const momentDate = moment(date, currentDateFormat);
    return momentDate.format(apiDateFormat);
};